var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenyesuaianStok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.09668H20.1667",
    stroke: "#718096",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.035 1.83331H18.1317C19.7633 1.83331 20.1667 2.23665 20.1667 3.84998V7.61748C20.1667 9.23081 19.7633 9.63415 18.1317 9.63415H13.035C11.4033 9.63415 11 9.23081 11 7.61748V3.84998C11 2.23665 11.4033 1.83331 13.035 1.83331Z",
    stroke: "#718096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 15.6383H10.9999",
    stroke: "#718096",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86825 12.375H8.96492C10.5966 12.375 10.9999 12.7783 10.9999 14.3917V18.1592C10.9999 19.7725 10.5966 20.1758 8.96492 20.1758H3.86825C2.23659 20.1758 1.83325 19.7725 1.83325 18.1592V14.3917C1.83325 12.7783 2.23659 12.375 3.86825 12.375Z",
    stroke: "#718096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 13.75C20.1667 17.2975 17.2975 20.1667 13.75 20.1667L14.7125 18.5625",
    stroke: "#718096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 8.24998C1.83325 4.70248 4.70242 1.83331 8.24992 1.83331L7.28743 3.43748",
    stroke: "#718096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenyesuaianStok);
export default __webpack_public_path__ + "static/media/penyesuaian-stok.cc727b97f809d0d9d0fee7a73de094f8.svg";
export { ForwardRef as ReactComponent };